import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const CenterClassroomRedux = createActions(
  {
    getClassroomRequest: ['centerId'],
    getClassroomSuccess: ['results'],
    getClassroomError: ['error'],
    updateVirtualCheckin: ['data'],
  },
  {
    prefix: 'CENTER_CLASSROOM_',
    defaultActions: {
    },
  },
)

const { Types, Creators } = CenterClassroomRedux
export const CenterClassroomTypes = Types
export default Creators

export const INITIAL_STATE = createState({
}, {
  get: true,
})

const getClassroomRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, d)

const getClassroomSuccess = (state, { results }) =>
  state.merge({ get: { fetching: false, error: null, results } }, d)

const getClassroomError = (state, { error }) =>
  state.merge({ get: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.getClassroomRequest]: getClassroomRequest,
    [Types.getClassroomSuccess]: getClassroomSuccess,
    [Types.getClassroomError]: getClassroomError,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CenterClassroomRedux.js